function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M503.2,592.89274l-87.38,144.21.18,14.65q-9.585.07508-18.99-.31994l4.35-188.33-.12-1.45.16-.28.41-17.8-95.88-139.21L401.7,530.25272l.34,3.76,3.28-142.29-82.82-144.32,83.06,119.33-.57-192.44-.18-63h.84l1.49,63,3.08,129.97,75.47-94.38-75.23,114.39,1.65,127.28,69.46-124.22-69.2,142.93.91,70.77,101.01-173.03L413.59,565.72276l2.05,157.37Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  points: "682.29 438.71 654.64 493 585.37 629 569.47 629 569.81 614.28 486.28 493 473.93 475.07 487.57 493 569.7 600.96 570.04 604.72 572.62 493 573.32 462.43 490.5 318.11 573.56 437.44 572.69 142.65 572.69 141.67 572.72 142.64 578.22 374.97 653.69 280.59 578.46 394.98 579.73 493 580.11 522.26 596.47 493 649.57 398.04 603.59 493 580.37 540.97 581.28 611.74 650.6 493 682.29 438.71",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M859.79064,738.38466c0,12.57275-116.406,50.32258-260,50.32258s-260-37.74983-260-50.32258,116.406,4.79262,260,4.79262S859.79064,725.81191,859.79064,738.38466Z",
  transform: "translate(-220 -111.29276)",
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M859.79064,738.38466c0,12.57275-116.406,50.32258-260,50.32258s-260-37.74983-260-50.32258,116.406,4.79262,260,4.79262S859.79064,725.81191,859.79064,738.38466Z",
  transform: "translate(-220 -111.29276)",
  opacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 379.79064,
  cy: 627.09189,
  rx: 260,
  ry: 22.76498,
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 377.79064,
  cy: 629.3707,
  rx: 107,
  ry: 10,
  opacity: 0.2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M806.17052,510.92322H689.29064v.74024h-279.5v40.50018c0,104.10559,84.39423,188.49982,188.49982,188.49982h.00036a188.40822,188.40822,0,0,0,162.83246-93.5h45.04724a68.12012,68.12012,0,1,0,0-136.24024Zm0,115.24024H771.70306a187.87964,187.87964,0,0,0,15.08758-73.99982V531.92322h19.37988a47.12012,47.12012,0,1,1,0,94.24024Z",
  transform: "translate(-220 -111.29276)",
  fill: "#3f3d56"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M427.29064,529.16346v23c0,94.29,76.71045,171,171,171,94.29,0,171-76.71,171-171v-23Z",
  transform: "translate(-220 -111.29276)",
  fill: "#90caf9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M553.57921,691.83153l-39.14805-40.3463a21.39132,21.39132,0,0,1,.45594-30.24845l59.20968-57.4512a15.07125,15.07125,0,0,1,4.90293-3.179l12.861-5.139a15.07129,15.07129,0,0,1,16.40865,3.50019l40.88125,42.13255a15.07127,15.07127,0,0,1,3.20945,16.01046l-4.32624,11.002a15.07137,15.07137,0,0,1-3.5307,5.30112l-60.67547,58.87347A21.39132,21.39132,0,0,1,553.57921,691.83153Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 608.31314,
  y: 583.78372,
  width: 27.31034,
  height: 4.09655,
  transform: "translate(389.29081 -379.79266) rotate(45.86357)",
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M623.82448,586.865c3.46216-8.21239,13.77753-9.98185,21.44955-11.6099,8.15615-1.73078,17.44616-4.7423,20.83431-13.22447a11.24,11.24,0,0,0-1.09541-10.72608c-1.99388-2.8597-5.35065-5.18676-8.98028-4.86174-7.59538.68014-8.94833,9.65118-6.04668,15.31227,3.91673,7.64149,13.97531,8.30731,21.50242,8.49584,7.27156.18213,15.07464-.09679,21.71965-3.38207a17.83785,17.83785,0,0,0,10.01438-16.83762c-.23351-7.33736-3.47133-14.18258-5.40419-21.1553-1.85768-6.70151-2.44211-14.1325,2.50377-19.706,4.79229-5.40042,12.34629-7.53307,19.23393-8.62253,1.76841-.27972,3.54847-.47027,5.33275-.61378,1.9113-.15373,1.9278-3.15506,0-3-12.7701,1.02712-29.50561,5.42681-31.33993,20.50708-.83842,6.8928,1.76634,13.6938,3.8677,20.1291,1.95314,5.98135,4.23823,12.87115,1.73914,19.0407-2.62356,6.47687-9.41624,9.11211-15.85132,10.10037a63.179,63.179,0,0,1-10.47233.567A48.15531,48.15531,0,0,1,660.769,566.0658c-3.38717-.929-6.65267-2.70782-8.25867-5.95792-1.18017-2.38832-1.55733-5.61035-.23424-8.02242a5.19048,5.19048,0,0,1,7.32576-1.83049,8.5832,8.5832,0,0,1,4.36377,8.27192c-1.09688,8.49836-10.81291,11.91132-17.92513,13.49648-7.83449,1.74613-16.67391,3.02577-22.26986,9.437a16.80327,16.80327,0,0,0-2.839,4.60711,1.51008,1.51008,0,0,0,1.04766,1.84518,1.5372,1.5372,0,0,0,1.84518-1.04766Z",
  transform: "translate(-220 -111.29276)",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 282.79064,
  cy: 452.3707,
  r: 11,
  fill: "#e6e6e6"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 484.79064,
  cy: 493.3707,
  r: 11,
  fill: "#e6e6e6"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 429.79064,
  cy: 551.3707,
  r: 8,
  fill: "#e6e6e6"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M364.60985,734.89808c32.6679,7.28769,68.72037,1.90328,68.72037,1.90328s-16.91266-17.20008-49.58055-24.48776-68.72037-1.90329-68.72037-1.90329S331.942,727.61039,364.60985,734.89808Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M367.83212,747.1873c35.56617,1.02625,65.74587-10.43588,65.74587-10.43588a173.12291,173.12291,0,0,0-63.05059-14.15228c-35.56617-1.02625-65.74588,10.43588-65.74588,10.43588A173.123,173.123,0,0,0,367.83212,747.1873Z",
  transform: "translate(-220 -111.29276)",
  fill: "#90caf9"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M370.35844,722.64051c25.40839,12.8098,62.82729,14.41132,62.82729,14.41132s-3.77625-19.16725-29.18465-31.977-62.82729-14.41132-62.82729-14.41132S344.95,709.83072,370.35844,722.64051Z",
  transform: "translate(-220 -111.29276)",
  fill: "#90caf9"
});

var _ref19 = /*#__PURE__*/React.createElement("polygon", {
  points: "760 63 760 0 63 0 0 0 0 63 0 300 0 363 0 624 63 624 63 363 760 363 760 300 63 300 63 63 760 63",
  fill: "#e6e6e6"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 697,
  y: 5,
  width: 63,
  height: 618,
  fill: "#e6e6e6"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M426.79064,529.66346v23c0,94.29,76.71045,171,171,171,94.29,0,171-76.71,171-171v-23Z",
  transform: "translate(-220 -111.29276)",
  fill: "#90caf9",
  opacity: 0.3
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M340.133,572.30733c-5.80748,9.01245-12.27029,9.30079-17.741,5.77553q-.19061-.12283-.37607-.24961-.37394-.255-.72573-.5269c-4.6654-3.604-6.37025-9.38409-.96931-17.76564,5.5893-8.67387,21.82-13.70656,23.02977-14.07243l.00168,0,.06935-.02079S345.94,563.29562,340.133,572.30733Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M743.133,341.13182c-5.80748,9.01245-12.27029,9.30079-17.741,5.77553q-.19061-.12283-.37607-.24962-.37393-.255-.72573-.52689c-4.6654-3.604-6.37025-9.38409-.96931-17.76565,5.5893-8.67387,21.82-13.70656,23.02977-14.07243l.00168,0,.06935-.0208S748.94,332.1201,743.133,341.13182Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M513.16781,274.24629c7.26272,7.887,5.91683,14.21463,1.12929,18.62325q-.16682.15362-.33616.30123-.3408.29781-.69244.56994c-4.66124,3.60936-10.68432,3.80612-17.43863-3.52872-6.98987-7.59065-7.77994-24.5653-7.82987-25.82822l.00047-.00162-.0027-.07234S505.90569,266.36,513.16781,274.24629Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M751.17595,528.04011l-17.22932,8.69105a7.09841,7.09841,0,0,1-9.63006-2.78717l-11.85612-23.50383a4.51619,4.51619,0,0,1-.47664-1.80825l-.22625-4.4635a5.19025,5.19025,0,0,1,2.92976-4.81539l17.99211-9.07583a5.20813,5.20813,0,0,1,5.47774.39819l3.04384,2.31229a4.52456,4.52456,0,0,1,1.30713,1.56551l12.14963,24.0857A7.0984,7.0984,0,0,1,751.17595,528.04011Z",
  transform: "translate(-220 -111.29276)",
  fill: "#e6e6e6"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 720.10807,
  y: 496.77269,
  width: 9.37458,
  height: 1.30715,
  transform: "translate(-366.35925 268.44389) rotate(-26.76791)",
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 719.13281,
  y: 503.29343,
  width: 20.74828,
  height: 5.99983,
  transform: "translate(-369.2757 267.50787) rotate(-26.50666)",
  fill: "#90caf9"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 723.13281,
  y: 510.29343,
  width: 20.74828,
  height: 5.99983,
  transform: "translate(-371.97934 270.0289) rotate(-26.50666)",
  fill: "#90caf9"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 727.13281,
  y: 518.29343,
  width: 20.74828,
  height: 5.99983,
  transform: "translate(-375.12929 272.65504) rotate(-26.50666)",
  fill: "#90caf9"
});

function SvgUndrawCupOfTea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a525f49c-389c-445f-ad2c-d5c197cff10c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 677.41447,
    viewBox: "0 0 760 677.41447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cup_of_tea") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCupOfTea);
export default __webpack_public_path__ + "static/media/undraw_cup_of_tea.023017c90135202a2f9fc10f3f3fd881.svg";
export { ForwardRef as ReactComponent };